import { show } from "@intercom/messenger-js-sdk";
import { useCallback } from "react";

const intercomAppId = import.meta.env.VITE_INTERCOM_APP_ID;

/**
 * Opens the Intercom messenger on demand.
 *
 * `PersistentLayout` is the single boot site — it boots Intercom on every viewport
 * (the launcher is just hidden on narrow ones), so there is always an instance to
 * show and this only needs to call `show()`.
 */
export function useIntercom() {
  const openMessenger = useCallback(() => {
    if (!intercomAppId) return;
    show();
  }, []);

  return { openMessenger };
}
